import { addElementsToPlan } from "../api";

export const addElementToPlan = async (elementId, planId, columnId, topicId) => {
    const response = await addElementsToPlan([elementId], planId, columnId, true, topicId);

    window.postMessage(
        JSON.stringify({
            messageName: "SendElementIdToCourseFeature",
            relatedEntityId: planId,
            customId: columnId
        }),
        "*"
    );

    return response;
};
